<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>
<script>
import * as echarts from 'echarts';
import resize from "@/components/chart/mixins/resize";
let chartVm = null;
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    id: {
      type: String,
      default: "chart6",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    chartData: {
      type: Object,
      default: {},
    },
    unit: {
      type: String,
      default: "万元",
    },
    max: {
      type: Number,
      default() {
        return 10
      }
    },
    min: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  data() {
    return {
      chart: null,
      // 立体柱状图颜色
      colorArr: [['rgba(7, 125, 68, ', 'rgba(25, 218, 125, '],['rgba(4, 93, 50, ','rgba(3, 117, 62, '], ['rgba(125, 85, 6, ', 'rgba(217, 152, 24, '],['rgba(92, 62, 4, ','rgba(117, 79, 4, ']],
      options: {
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0, 81, 28, 0.5)',
          position: function (point, params, dom, rect) {
            if(params.data == 0.01) {
              return [rect.x + rect.width / 2 - 8, rect.y - 36]; // 居中显示在柱顶上方
            }else {
              return [rect.x + rect.width / 2 - 20, rect.y - 36]; // 居中显示在柱顶上方
            }
          },
          formatter(params) {
            let dom = '';
            [params].map(v=>{
              dom+= `
              <div style="background: rgba(0, 81, 28, 0.5);border-radius: 4px;font-size:12px;color: #95FFBA;font-weight:400;line-height:1;">${(v.value || 0).toFixed(2)}</div>`
            });
            return `<div>${dom}</div>`;
          }
        },
        legend: {
          show: false,
          orient: "horizontal",
          x: "right",
          y: "10",
          itemWidth: 10,
          itemHeight: 10,
          itemStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(13, 255, 169, 1)", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "rgba(13, 255, 169, 0.3)", // 100% 处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
          },
          textStyle: {
            color: "#FFFFFF",
            fontSize: "12",
          },
        },
        grid: {
          right: "10%",
          left: "11%",
          top: "25%",
          bottom: "20%"
        },
        xAxis: {
          type: "category",
          axisTick: {
            //y轴刻度线
            show: false,
          },
          offset: 8,
          axisLabel: {
            interval: 0,
            color: '#BABBBD',
            fontSize: 12,
          },
          axisLine: {
            show: false,
          },
          data: [],
        },
        yAxis: {
          name: `（${this.unit || '万元'}）`,
          min: 0,
          max: 10,
          type: "value",
          nameTextStyle: {
            color: '#BABBBD',
            fontSize: 13,
            align: 'right',
          },
          axisLabel: {
            color: '#BABBBD',
            fontSize: 12,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#FFFFFF",
            },
            width: 5,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "rgba(13, 255, 169, 0.1)",
            },
          },
        },
        series: [],
      },
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.initChart();
      },
    },
  },
  mounted() {
    this.initChart();
    chartVm = this;
  },
  activated() {
    this.$nextTick(function () {
      setTimeout(() => {
        this.chart.resize();
      }, 300);
    });
  },
  created() {},
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setChartData() {
      this.options.yAxis.name = `（${this.unit || '万元'}）`;
      let series = [];
      let that = this;
      if (this.chartData.num && this.chartData.num.length > 0) {
        // 为了实现立体效果，把两个柱子并在一起
        series.push({
          name: 'leftBar',
          type: "bar",
          barGap: 0,
          barWidth: "10",
          label: {
            show: false,
            position: "insideLeft",
            formatter(v) {
              if (v.value) {
                return "";
              } else {
                return v.value;
              }
            },
          },
          itemStyle: {
            normal: {
              color: function(params) {
                return  new echarts.graphic.LinearGradient(0,0,0,1, 
                  //渐变色在下面修改，这里是透明度
                  [
                    {
                      offset: 0,
                      color: that.colorArr[0][1] + '1)',
                    },
                    {
                      offset: 1,
                      color: that.colorArr[0][0] + '1)',
                    },
                  ]
                );
              }
            },
            emphasis: { // 鼠标悬浮时的样式
              color: new echarts.graphic.LinearGradient(0,0,0,1,
                  //渐变色在下面修改，这里是透明度
                  [
                    {
                      offset: 0,
                      color: that.colorArr[2][1] + '1)',
                    },
                    {
                      offset: 1,
                      color: that.colorArr[2][0] + '1)',
                    },
                  ]
                )
            }
          },
          data: this.chartData.num,
          z: 5,
          zlevel: 10,
        });
        series.push({
          name: 'rightBar',
          type: "bar",
          barWidth: "10",
          barGap: 0,
          label: {
            show: false,
            position: "insideLeft",
            formatter(v) {
              if (v.value) {
                return "";
              } else {
                return v.value;
              }
            },
          },
          itemStyle: {
            normal: {
              color: function(params) {
                return new echarts.graphic.LinearGradient(0,0,0,1, 
                  //渐变色在下面修改，这里是透明度
                  [
                    {
                      offset: 0,
                      color: that.colorArr[1][1] + '1)',
                    },
                    {
                      offset: 1,
                      color: that.colorArr[1][0] + '1)',
                    },
                  ]
                );
              }
            },
            emphasis: { // 鼠标悬浮时的样式
              color: new echarts.graphic.LinearGradient(0,0,0,1, 
                //渐变色在下面修改，这里是透明度
                [
                  {
                    offset: 0,
                    color: that.colorArr[3][1] + '1)',
                  },
                  {
                    offset: 1,
                    color: that.colorArr[3][0] + '1)',
                  },
                ]
              )
            }
          },
          data: this.chartData.num,
          z: 5,
          zlevel: 10,
        });
        series.push(
          {
              // 最下面菱形
              data: this.chartData.num,
              type: 'pictorialBar',
              symbol: 'diamond',
              symbolSize: [20, 10],
              symbolPosition: 'end',
              symbolOffset: [0, -5],
              itemStyle: {
                normal: {
                  color: function(params) {
                    return that.colorArr[0][1] + '1)';
                  }
                },
                emphasis: { // 鼠标悬浮时的样式
                  color: 'rgba(255, 193, 69, 1)'
                }
              },
              z: 6,
              zlevel: 10,
            }
        );

        this.options.xAxis.data = this.chartData.years;
        this.options.yAxis.min = this.min;
        this.options.yAxis.max = this.max;
        this.options.series = series;
        this.chart.setOption(this.options);
      } else {
        this.options.xAxis.data = [];
        this.options.series = [];
        this.chart.setOption(this.options,true); // 设置为true的话，就是notMerge，不合并,false的话，就Merge，之前的东西还保留~
      }

    },
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById(this.id));
      }
      this.setChartData();
      let _this = this;
      // 监听 hover 事件
      this.chart.on('mouseover', function(params) {
        const dataIndex = params.dataIndex;
        _this.chart.dispatchAction({
          type: 'highlight',
          seriesIndex: [0, 1, 2],
          dataIndex: dataIndex
        });
        _this.chart.dispatchAction({
          type: 'showTip',
          seriesIndex: [0, 1, 2],
          dataIndex: dataIndex
        });
      });
      // 监听移出事件
      this.chart.on('mouseout', function(params) {
        _this.chart.dispatchAction({
          type: 'downplay',
          seriesIndex: [0, 1, 2],
          dataIndex: params.dataIndex
        });
      });
    },
  },
};
</script>
